import { useEffect, useState } from 'react';

// Escreve, espera, apaga e escreve de novo, em loop, com cursor piscando.
function TypewriterText({ text, className, typeSpeed = 110, eraseSpeed = 55, holdFull = 2000, holdEmpty = 500 }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let timer;
    let n = 0;
    let erasing = false;
    setCount(0);
    const tick = () => {
      if (!erasing) {
        n++;
        setCount(n);
        if (n >= text.length) { erasing = true; timer = setTimeout(tick, holdFull); return; }
        timer = setTimeout(tick, typeSpeed);
      } else {
        n--;
        setCount(n);
        if (n <= 0) { erasing = false; timer = setTimeout(tick, holdEmpty); return; }
        timer = setTimeout(tick, eraseSpeed);
      }
    };
    timer = setTimeout(tick, typeSpeed);
    return () => clearTimeout(timer);
  }, [text, typeSpeed, eraseSpeed, holdFull, holdEmpty]);

  return (
    <span className={className} aria-label={text}>
      {text.slice(0, count)}<span className="typewriter-caret" aria-hidden="true" />
    </span>
  );
}

export default TypewriterText;
